// Imports
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "html {\n    font-size: 62.5%;\n  }\n  \n  body #root {\n    font-family: \"Quicksand\";\n    background-color: #f1faee;\n  }\n  ", "",{"version":3,"sources":["webpack://src/index.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B","sourcesContent":["html {\n    font-size: 62.5%;\n  }\n  \n  body #root {\n    font-family: \"Quicksand\";\n    background-color: #f1faee;\n  }\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
